// extracted by mini-css-extract-plugin
export default {"ctn":"headerMobile_ctn__y+yP+","posterBox":"headerMobile_posterBox__99z8m","fullScrenEle":"headerMobile_fullScrenEle__4Kolg"};